import {Col, Container, Row, media} from 'styled-bootstrap-grid';
import {Helmet} from "react-helmet";
import PageTitle from "../../../PageTitle/components/PageTitle";
import React, {Fragment} from 'react';
import styled from 'styled-components';
import {withRouter} from 'react-router-dom';
import PageNavigation from "../../../PageNavigation/components/PageNavigation";
import GetInTouch from "../../../GetInTouch/components/GetInTouch";
import ViewMoreLink from "../../../ViewMoreLink/components/ViewMoreLink";

const Img = styled.img`
  width: 100%;
`;
const H3 = styled.h3`
  font-weight: 400;
  font-size: 1.7rem;
  margin: 0 0 1rem;
`;
// const InfoTag = styled.p`
//   font-size: 1rem;
//   font-weight: 400;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   color: #717476;
//   margin: 0 0 0.5rem;
// `;
const P = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 4rem;
  
  ${media.lg`
    margin-bottom: 0;
  `}
`;

const IndustryTagWrap = styled.div`
  margin-bottom: 4rem;
`;
const IndustryTag = styled.div`
  display: inline-block;
  padding: 0 2rem;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-right: 1rem;
  height: 3rem;
  border-radius: 2rem;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 3rem;
  text-transform: uppercase;
`;

const ServiceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: 1px solid #d7d7d7;
`;
const ServiceItem = styled.li`
  display: block;
  border-bottom: 1px solid #d7d7d7;
  padding: 1rem;
`;
const ServiceTag = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 0;
`;
const ServiceName = styled.p`
  color: #212529;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
`;

const LightWrap = styled.div`
  background: #fff;
  padding: ${({padding}) => (padding) ? padding : '4rem 0'};
`;
const TransparentWrap = styled.div`
  padding: 4rem 0;
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const HankyPanky = (props) => {
  return <Fragment>
    <Helmet>
      <meta name="description" content=""/>
      <title>Case Study: Hanky Panky | RMG</title>
      <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
    </Helmet>
    <PageTitle heading="Case Study"
               subHeading="Hanky Panky"
    />
    <Container fluid>
      <Row>
        <Col col={12} noGutter={true}>
          <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/HankyPanky_Hero-Opt.jpg"/>
        </Col>
      </Row>
    </Container>
    <Container>
      <StyledRow>
        <StyledCol col={12} lg={6}>
          <IndustryTagWrap>
            <IndustryTag>Fashion</IndustryTag>
            <IndustryTag>Apparel</IndustryTag>
            <IndustryTag>Women's</IndustryTag>
          </IndustryTagWrap>
          <H3>
            About Hanky Panky
          </H3>
          <P>
            In 1977, designer Gale Epstein created a handmade lingerie set for her friend, Lida Orzeck, crafted out of
            embroidered handkerchiefs. The original designs wowed retailers and industry experts and were the
            inspiration for the company name Hanky Panky. With the inception of the hanky set in the seventies to the
            thongs of today, Hanky Panky continues to influence trends in lingerie and sleepwear.
          </P>
          <P>
            By blending traditional and modern glam looks, Hanky Panky proudly provides brilliant solutions for fashion
            fit issues by remaining dedicated to innovative design, comfort, quality, and US production. Hanky Panky
            partnered with RMG to bring that same dedication to quality and design to their online brand experience with
            a headless commerce implementation on Magento 2.
          </P>
        </StyledCol>
        <Col col={12} lgOffset={2} lg={4}>
          <H3>
            How We Helped
          </H3>
          <ServiceList>
            <ServiceItem>
              <ServiceTag>Creative</ServiceTag>
              <ServiceName>Mobile Responsive Design</ServiceName>
              <ServiceName>User Experience Design</ServiceName>
              <ServiceName>User Interface Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Development</ServiceTag>
              <ServiceName>B2C & B2B Implementation</ServiceName>
              <ServiceName>Backend Development</ServiceName>
              <ServiceName>Frontend Development</ServiceName>
              <ServiceName>Software Architecture Design</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Devops</ServiceTag>
              <ServiceName>Application &amp; Infrastructure Support</ServiceName>
              <ServiceName>Managed Cloud Hosting</ServiceName>
              <ServiceName>Software Development Lifecycle Management</ServiceName>
            </ServiceItem>
          </ServiceList>
        </Col>
      </StyledRow>
    </Container>
    <LightWrap>
      <Container>
        <Row>
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*  <div><P>As their selection of bags and options continued to grow, Rickshaw partnered with RMG to streamline their online brand experience make it feel like it does in-store. To bring this level of customization online, RMG first replatformed Rickshaw from Magento 1 to Magento 2. During the data migration, RMG made updates to the infrastructure responsible for storing product and customer data, increasing security and functional reliability. These backend updates also allow Rickshaw to rapidly iterate on designs and store their new creations as product/option variations, greatly reducing the time-to-market for new offerings.</P></div>*/}
          {/*  <div><P>This feature immediately gave Rickshaw Bags a huge return on their investment by allowing them to remain open as an essential business and produce facemasks during the COVID-19 pandemic, increasing their pageviews and conversation rate by over 400% and their revenue by almost 500%.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/600x600" /></div>*/}
          {/*  <div><P>After transforming Rickshaw's core digital experience, the same treatment was applied to the rest of the business by adding new shipping methods and options, upgrading their invoice processing, and revamping their blog. Together, these changes help Rickshaw scale their business as their options continue to expand and attract new audiences through their strong content-to-commerce funnel. By working with RMG, Rickshaw Bagworks was able to bring their renowned in-store experience online and expand their reach well beyond their San Francisco storefront.</P></div>*/}
          {/*</Col>*/}
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><P>At the core of Rickshaw's brand experience is the ability to customize a bag's flap, body, inner lining, bindings, buckles, labels, and straps, each of which comes in multiple colors and fabrics. Because of their extraordinary selection, Rickshaw staff's knowledgeable designers to help customers build the best bags based on their needs. In addition, Rickshaw designs and manufactures many custom fabrics, which greatly expands the audiences and applications their products cater to.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/800x1000" /></div>*/}
          {/*  <div><P>On the frontend, RMG built a specialized product customizer which allowed for multiple interacting filters, such as part color and fabric. This customizer also allows customers to make unique, personalized color variations which can be applied across all of Rickshaw's products. In addition, RMG redesigned Rickshaw's entire customer journey to be mobile-first, allowing customers to navigate the customization process with ease regardless of the device they use. As part of this redesign, RMG restyled most of the imagery across the site, even adding support for moving GIF images. We also streamlined Rickshaw's product, catalog, cart, and checkout pages to minimize friction and provide better responsiveness.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*</Col>*/}
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/HankyPanky_img_01.png"/>
          </Col>
          <Col col={12} lg={6}>
            <P>
              Hanky Panky set a new standard for thongs when their famous 4811 was introduced in 1986. In a front-page
              Wall Street Journal article in 2004, "lace butter" was the term used to describe Hanky Panky products.
              Leading fashion magazines and celebrities regularly extol their revolutionary comfort and beauty. As their
              loyal fanbase and catalog of premiere designs continued to grow, they partnered with RMG to ensure their
              online experience satisfies their customers as much as their signature lace products do. To Hanky Panky,
              this meant creating a fast and engaging customer journey that features a streamlined product personalizer
              and a frictionless one-step checkout.
            </P>
            <P>
              To RMG, this meant migrating their backend from Magento 1 to Magento 2 and upgrading their frontend to
              progressive web app technology through our accelerator program. This way, RMG could leverage state-of-the-
              art technologies to ensure Hanky Panky's website was fast and smooth, even during complex parts of the
              customer journey like customizing and personalizing a product.
            </P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>
              Once the product data and imagery were mirgated and optimized, RMG reintegrated them with our technology
              partner Reflektion, who provides a robust solution for product recommendations inside Hanky Panky's
              category, product, and checkout experiences. RMG also made sure that their system for loyalty and reward
              points, called Panky Points, was built into the sitewide interface to limit the number of steps a customer
              must take before reaching checkout. With these changes, customers can always access the discounts and
              rewards they have accrued without backtracking and losing progress in their shopping experience, making
              them more likely to follow on-site recommendations and calls to action.
            </P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/HankyPanky_img_03.png"/>
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <LightWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/HankyPanky_img_02.png"/>
          </Col>
          <Col col={12} lg={6}>
            <P>
              Next, RMG designed and developed a custom drag-and-drop product personalizer, which allows customers to
              add custom features such as gemstone lettering. Utilizing our partner Adobe's product Scene7, the images
              for the customized product components are overlaid and layered to show an updated preview image of the
              customized product in real-time. Finally, when the customer has filled their cart, they can enjoy Hanky
              Panky's streamlined one-step checkout.
            </P>
            <P>
              Together, these changes greatly enhance Hanky Panky's end-to-end customer journey, resulting in an
              engaging, responsive, and high-conversion brand experience. By partnering with RMG and leveraging our PWA
              Accelerator program, Hanky Panky can focus on growing their stylish brand and keeping customer coming back
              for the design, quality, and comfort they love.
            </P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <LightWrap>
      <Container>
        <Row>
          <NavCol col={12}>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                          to={`/portfolio/h-e-b`}
                          buttonText="H-E-B"/>
            <NavSpan>/</NavSpan>
            <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/cbdmd`}
                          buttonText="cbdMD"/>
          </NavCol>
        </Row>
      </Container>
    </LightWrap>
    <GetInTouch title="Get In Touch"
                text="You could be our next case study."
                buttonText="Let's talk"
                useArrow
    />
    <PageNavigation prev="capabilities" next="insights"/>
  </Fragment>;
};

export default withRouter(HankyPanky);